<template>
  <svg
    aria-hidden="true"
    focusable="false"
    role="img"
    class="inline"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    :viewBox="viewBox"
    :height="height"
    :width="width"
  >
    <slot></slot>
  </svg>
</template>

<script>
export default {
  name: 'SVGIcon',
  props: {
    viewBox: {
      type: String,
      default: () => '0 0 512 512',
    },
    height: {
      type: [Number, String],
      default: () => 20,
    },
    width: {
      type: [Number, String],
      default: () => 20,
    },
  },
};
</script>

<style scoped>

</style>
